/* tslint:disable */
/* eslint-disable */
/**
 * Jobs API
 * Backend de bolsa de trabajo para alumno, empresa y admin.  Pantallas de Alumno [P_A_xx]   https://app.axure.cloud/app/project/5t0fsq/overview  Pantallas de empresa [P_E_xx]    https://app.axure.cloud/app/project/jcj3w8/overview
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import {
    CandidateOfferItem,
    CandidateOfferItemFromJSON,
    CandidateOfferItemFromJSONTyped,
    CandidateOfferItemToJSON,
    Pagination,
    PaginationFromJSON,
    PaginationFromJSONTyped,
    PaginationToJSON,
} from './';

/**
 * Item ligero de oferta para listados vista candidato paginado [P_A_02] [P_A_11]
 * @export
 * @interface CandidateOfferItemPaginated
 */
export interface CandidateOfferItemPaginated {
    /**
     * 
     * @type {Array<CandidateOfferItem>}
     * @memberof CandidateOfferItemPaginated
     */
    data?: Array<CandidateOfferItem>;
    /**
     * 
     * @type {Pagination}
     * @memberof CandidateOfferItemPaginated
     */
    pagination?: Pagination;
}

export function CandidateOfferItemPaginatedFromJSON(json: any): CandidateOfferItemPaginated {
    return CandidateOfferItemPaginatedFromJSONTyped(json, false);
}

export function CandidateOfferItemPaginatedFromJSONTyped(json: any, ignoreDiscriminator: boolean): CandidateOfferItemPaginated {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'data': !exists(json, 'data') ? undefined : ((json['data'] as Array<any>).map(CandidateOfferItemFromJSON)),
        'pagination': !exists(json, 'pagination') ? undefined : PaginationFromJSON(json['pagination']),
    };
}

export function CandidateOfferItemPaginatedToJSON(value?: CandidateOfferItemPaginated | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'data': value.data === undefined ? undefined : ((value.data as Array<any>).map(CandidateOfferItemToJSON)),
        'pagination': PaginationToJSON(value.pagination),
    };
}


